export default __webpack_public_path__ + "static/media/illustration.3417da25.svg";